import React, { useState } from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import BusinessModelsSection from '../businessModels';
import { Helmet } from "react-helmet-async";
import m1 from './Mobile icon  (2)/1.png';
import m2 from './Mobile icon  (2)/2.png';
import m3 from './Mobile icon  (2)/3.png';
import Team from '../../../../assests/servicePage.png'
import Service from '../../../../assests/service.png'
import bgimage from '../../../../assests/webiconF (3)/4.png'
import {
  FaHtml5,
  FaCss3Alt,
  FaJs,
  FaAngular,
  FaReact,
  FaVuejs,
  FaPhp,
  FaPython,
  FaNodeJs,
  FaJava,
  FaAws,
} from "react-icons/fa";

import {
  SiDotnet,
  SiFlutter,
  SiMysql,
  SiOnnx,
  SiMariadb,
  SiSqlite,
  SiDjango,
  SiMlflow,
  SiGooglecloud,
  SiMongodb,
  SiPostgresql,
} from "react-icons/si";
const tabs = [
  {
    title: "1.React Native Application Development ",
    content: (
      <>
        <h3 className="lg:text-2xl text-[44px] font-semibold text-[#0A2C4C] font-recoleta mb-4">Share the requirement</h3>
        <p className="lg:text-[19px] text-[34px] text-[#0A2C4C] mb-4 font-recoleta">
          Understanding client requirements is key when it comes to staffing solutions. We ask our clients their demands, requirements, and goals to carefully analyze the suitable employees to recruit for their business.
        </p>
        <img
          src="/images/Image%2026.png"
          alt="UI/UX Design "
          className="w-[260px] h-[194px] rounded-md"
        />
      </>
    ),
  },
  {
    title: "2. Flutter Development",
    content: (
      <p className="lg:text-[19px] text-[34px] text-[#0A2C4C] font-recoleta">
        We evaluate all candidates and shortlist only those who align with the client’s business, technical, and cultural requirements.
      </p>
    ),
  },
  {
    title: "3. Native Application Development",
    content: (
      <>
        <h4 className="text-xl font-semibold text-[#0A2C4C] font-recoleta mb-2">Battery replacement</h4>
        <p className="lg:text-[19px] text-[34px] text-[#0A2C4C]">
          Your device may get switched off often despite charging it. Whether it is battery draining quickly or not holding charge, we offer replacement and warranty.
        </p>
        <img
          src="https://static.zohocdn.com/sites/stock-images/images/zpstock-image-1263.webp"
          alt="Battery replacement"
          className="w-full max-w-md mt-4 rounded-md"
        />
      </>
    ),
  },
  {
    title: "4. Support & Maintenance",
    content: <p className="lg:text-[19px] text-[34px] text-[#0A2C4C]">We ensure smooth onboarding of selected candidates by handling documentation and welcome sessions.</p>,
  }
];

const services = [
  {
    icon: m1,
    title: "React Native",
    description:
      "The creative process of developing application programs that reside on remote servers by using client-side and server-side programming.",
  },
  {
    icon: m2,
    title: "Flutter",
    description:
      "We provide extensive mobile app maintenance services that cover all aspects of app maintenance, from troubleshooting to content alteration to reengineering.",
  },
  {
    icon: m3,
    title: "JavaScript",
    description:
      "Having a Content Management System for your website allows you to control the content without getting into coding technicalities.",
  },
  // {
  //   icon: "https://www.tekitsolution.com/webmaint.png",
  //   title: "Support & Maintenance",
  //   description:
  //     "Regularly updating, modifying, and enhancing software applications to improve your website's performance and design.",
  // },
];

const tab = [
  {
    name: "Mobile App",
    items: [
      { name: "React Native", icon: <FaReact /> },
      { name: "Flutter", icon: <SiFlutter /> },
      { name: "JavaScript", icon: <FaJs /> },
      // { name: "Angular", icon: <FaAngular /> },
      // { name: "React", icon: <FaReact /> },
      // { name: "Vue.js", icon: <FaVuejs /> },
    ],
  },
  {
    name: "Back End",
    items: [
      { name: "PHP", icon: <FaPhp /> },
      { name: "Python", icon: <FaPython /> },
      { name: "Node.js", icon: <FaNodeJs /> },
      { name: ".NET", icon: <SiDotnet /> },
      { name: "Java", icon: <FaJava /> },
      { name: "Onnx", icon: <SiOnnx /> },
      { name: "Django", icon: <SiDjango /> },
      { name: "Mlflow", icon: <SiMlflow /> },

    ],
  },
  {
    name: "Databases",
    items: [
      { name: "MariaDB", icon: <SiMariadb /> },
      { name: "SQLite", icon: <SiSqlite /> },
      { name: "Mongodb", icon: <SiMongodb /> },
      { name: "Postgres", icon: <SiPostgresql /> },
      { name: "Mysql", icon: <SiMysql /> },
    ],
  },
  {
    name: "Cloud",
    items: [
      { name: "AWS", icon: <FaAws /> },
      { name: "Google Cloud", icon: <SiGooglecloud /> },
    ],
  },
];

const mobile_development = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [activeTab, setActiveTab] = useState("Mobile App");
  const currentTab = tab.find((t) => t.name === activeTab);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [message, setMessage] = useState('');

  const [formData, setFormData] = useState({
    phone: '',
    email: '',
  });


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const validate = () => {
    let newErrors = {};
    if (!formData.phone.trim()) newErrors.phone = 'Phone is required';
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }
    return newErrors;
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length === 0) {
      try {
        // Add a "type" to formData before sending
        const payload = {
          ...formData,
          type: 'Mobile_Development',
        };

        const response = await fetch('https://www.tekitsolution.com/email_apis.php?action=service', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: new URLSearchParams(payload).toString(),
        });

        const result = await response.json();
        alert('Form submitted successfully!');

        // Reset form
        setFormData({
          type: 'Mobile_Development',
          phone: '',
          email: '',
        });
        setMessage('Message sent successfully!');
        setErrors({});
      } catch (error) {
        console.error('Error:', error);
        alert('Something went wrong. Please try again.');
      }
    } else {
      setErrors(validationErrors);
      setMessage('');
    }
  };

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSelect = (index) => {
    setActiveIndex(index)
  }
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration
      once: true, // whether animation should happen only once
    });
  }, []);

  return (
    <div className='pt-0'>
      <Helmet>
        <title>Custom Mobile App Development | Build Smarter Apps | Tekit </title>
        <meta name="description" content="From idea to App Store — Tekit Solution delivers custom iOS & Android apps with clean code, stunning UI, and performance that speaks for itself." />
        <meta name="keywords" content="Mobile App Development, Custom Mobile Apps, iOS App Development, Android App Development, Cross-Platform Mobile Development, Native Mobile App Development, Mobile App Design, App Development Agency, Top IT Staff Augmentation Companies, IT Staffing Services, Largest IT Staffing Companies, Staffing IT, Contract IT Staffing, Staffing IT Services, IT Staffing, Staffing Solutions, IT Staffing Solutions, Premier Staffing Solutions, IT Services, Executive Staffing, Staffing Company, staffing services" />
      </Helmet>
      <div className="curslide">
        {/* Background Image with Gradient Overlay */}
        <div
          className="w-full h-[500px] lg:h-[380px] bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(${Service})` }}
        // style={{
        //   backgroundImage: `linear-gradient(to right, rgba(254, 247, 237, 1), rgba(255, 255, 255, 0)), url('https://static.zohocdn.com/sites/stock-images/images/zpstock-image-39.jpg')`,
        // }}
        ></div>

        {/* Hero Content */}
        <div className="absolute top-0 left-0 w-full h-full flex items-start justify-start">
          <div className="container mx-auto px-4 py-8">
            <div className="flex flex-col justify-start items-start h-full" style={{ placeItems: 'center' }}>
              <div className="w-full  mt-52 lg:mt-[100px]">
                <div className='flex justify-center items-center'>
                  <img src={bgimage} className="w-20 " />
                </div>
                <h1 className="text-center text-black font-bold font-recoleta text-[50px] 2xl:text-[50px] lg:text-[46px] " data-aos="fade-up">
                  Custom Mobile App Development Services That Deliver Results
                </h1>
                <h2 className="text-bold text-center text-[28px] lg:text-[24px] 2xl:text-[28px] text-black mt-4" data-aos="fade-up">
Scalable iOS & Android Apps Tailored to Your Business Goals                </h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <section className="px-4 py-10 bg-white">
          <div className="text-center mb-8">
            <h1 className="font-recoleta text-[54px] 2xl:text-[40px] lg:text-[32px]" data-aos="fade-up">Smart, Scalable, and User-Centric Mobile Solutions
            </h1>
          </div>

          <div className="grid grid-cols-1  lg:grid-cols-3 gap-6 max-w-7xl mx-auto mb-10">
            {services.map((service, idx) => (
              <div
                key={idx}
                className="bg-white border border-gray-200 rounded-lg p-6 shadow-md hover:shadow-lg transition duration-300"
              >
                <div className="flex justify-center mb-4">
                  <img
                    src={service.icon}
                    alt={`${service.title} Icon`}
                    className="lg:w-20 lg:h-20 w-44 h-44 object-contain"
                    
                  />
                </div>
                <h3 className="lg:text-xl text-[44px] font-semibold text-[#0A2C4C] text-center mb-3">{service.title}</h3>
                <p className="text-gray-700 lg:text-sm text-[34px] text-center">{service.description}</p>
                {/* <div className="mt-4 text-center">
                  <a
                    href="#"
                    className="text-[#F86F4B] font-semibold hover:underline transition"
                  >
                    Read More
                  </a>
                </div> */}
              </div>
            ))}
            {/* {tabs.map((tab, index) => (
          <button
            key={index}
            onClick={() => setActiveIndex(index)}
            className={`flex flex-col items-center text-center p-6 rounded-xl transition border-2 shadow-sm ${
              activeIndex === index
                ? "border-[#F86F4B] bg-[#fff6f3]"
                : "border-gray-200 hover:border-[#F86F4B]"
            }`}
          >
            <h4 className="text-lg font-semibold text-[#0A2C4C] mb-2">{tab.title}</h4>
            <p className="text-sm text-[#0A2C4C]">{tab.description}</p>
          </button>
        ))}
      </div> */}

            {/* Tab Content */}
            {/* <div className="bg-gray-50 max-w-4xl mx-auto p-6 rounded-xl shadow-md font-recoleta"> */}
            {/* {tabs[activeIndex].content} */}
          </div>

          {/* <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 max-w-7xl mx-auto relative z-0">
            <div className="space-y-2 col-span-1 z-1 relative">
              {tabs.map((tab, index) => (
                <button
                  key={index}
                  className={`w-full text-left px-4 py-3 rounded-md font-recoleta transition text-[44px] 2xl:text-[32px]  lg:text-[26px] ${activeIndex === index
                    ? "text-[#F86F4B] border-r-4 border-[#F86F4B] bg-[#fef2f2]"
                    : "text-[#0A2C4C] hover:text-[#F86F4B] hover:bg-gray-100"
                    }`}
                  onClick={() => handleSelect(index)}
                >
                  {tab.title}
                </button>
              ))}
            </div>

            <div className="text-[24px] col-span-1 lg:col-span-3 bg-gray-50 p-6 rounded-lg shadow-md h-fit relative z-0 font-recoleta">
              {tabs[activeIndex].content}
            </div>
          </div> */}
        </section>
        <section className="relative py-10 text-white font-recoleta">
          {/* Background Image */}
          <img
            src={Team}
            alt="img"
            className="absolute inset-0 w-full h-full object-cover z-0"
          />

          {/* Optional dark overlay */}
          <div className="absolute inset-0 z-0"></div>

          {/* Content */}
          <div className="relative z-1 container mx-auto px-4">
            {/* Title */}
            <div className="text-center mb-8">
              <h2 data-aos="fade-up" className="2xl:text-[40px] lg:text-[32px] text-[54px] font-bold mb-2">
                <strong>Technologies</strong> We Work With
              </h2>
              <p data-aos="fade-up" className="2xl:text-[26px]  lg:text-[20px] text-[34px]">
                Check out what programming languages, database systems, and platforms we use to complete projects for{" "}
                our clients
              </p>
            </div>

            {/* Tabs */}
            <div className="flex flex-wrap justify-center lg:gap-4 gap-4 mb-8">
              {tab.map((tab) => (
                <button
                  key={tab.name}
                  onClick={() => setActiveTab(tab.name)}
                  className={`px-4 2xl:text-[24px]  lg:text-[20px] text-[23px] py-2 rounded-3xl w-[170px] font-medium transition ${activeTab === tab.name
                    ? "bg-white text-black shadow"
                    : "bg-transparent text-white border border-white hover:text-white hover:border-white"
                    }`}
                >
                  {tab.name}
                </button>
              ))}
            </div>

            {/* Tab Content */}
            <div className="flex gap-4 justify-center mb-6">

            </div>

            {/* Tech Icons */}
            <div className=" grid-cols-2 lg:grid-cols-3 grid justify-center lg:px-40 gap-6">
              {currentTab?.items.map((tech) => (
                <div
                  key={tech.name} data-aos="fade-up"
                  className="bg-white text-black p-10  lg:mt-0 mt-10 rounded-lg shadow flex flex-col items-center justify-center"
                >
                  <div className="lg:text-4xl text-[80px] mb-2">{tech.icon}</div>
                  <p className="2xl:text-[24px]  lg:text-[20px] text-[60px] font-medium text-center">{tech.name}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        <BusinessModelsSection />
        <div className="p-4 lg:p-10 lg:px-48 px-10 bg-white font-recoleta">
          <h2 data-aos="fade-up" className="text-[54px] 2xl:text-[40px] lg:text-[32px] text-center font-bold text-[#002856] mb-8 font-recoleta">
            Schedule Call
          </h2>

          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">

              <div>
                <input
                  data-aos="fade-up"
                  name="email"
                  placeholder="Email *"
                  className="w-full border border-gray-300 p-4 rounded text-[32px] lg:text-[20px]"
                  value={formData.email}
                  onChange={handleChange}
                />
                {errors.email && <p className="text-red-500 text-[24px] lg:text-sm">{errors.email}</p>}
              </div>

              <div>
                <input
                  data-aos="fade-up"
                  name="phone"
                  placeholder="Phone"
                  className="w-full border border-gray-300 p-4 rounded text-[32px] lg:text-[20px]"
                  value={formData.phone}
                  onChange={handleChange}
                />
                {errors.phone && <p className="text-red-500 lg:text-sm text-[24px]">{errors.phone}</p>}

              </div>
            </div>

            <div className="justify-center gap-4 mt-6 grid grid-cols-1 px-10  lg:hidden justify-self-center">
              <button
                type="submit"
                className="bg-[#00447b] w-full text-white py-2 px-6 rounded-full hover:bg-[#00325c] duration-300 text-[28px] lg:text-[20px]"
              >
                Submit
              </button>
              {/* <button
                type="button"
                data-aos="fade-up"
                onClick={'handleReset'}
                className="bg-[#00447b] w-full text-white lg:mt-0 mt-4 py-2 px-6 rounded-full hover:bg-[#00325c] duration-300 text-[28px] lg:text-[20px]"
              >
                Reset
              </button> */}
            </div>
            <div className="justify-center gap-4 mt-6 lg:flex px-10 lg:block hidden">
              <button
                type="submit"
                data-aos="fade-up"
                className="bg-[#00447b] lg:w-52 w-full text-white py-2 px-6 rounded-full hover:bg-[#00325c] duration-300"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default mobile_development